import React from 'react';
import PropTypes from 'prop-types';
import { Table, Dropdown } from 'semantic-ui-react';

const ListRowComponent = ({ actionHandler, auctionAccessBlacklist }) => {
  const rowMenuOptions = [
    { key: 1, text: 'Edit', value: 'Edit' },
    { key: 2, text: 'Delete', value: 'Delete' },
  ];
  const {
    id, auctionAccessNo, expirationDate, notes, createdAt, status,
  } = auctionAccessBlacklist;

  const handleActionChange = (e, { value }) => {
    e.preventDefault();
    actionHandler(value, auctionAccessBlacklist);
  };

  return (
    <Table.Row key={id}>
      <Table.Cell>{auctionAccessNo}</Table.Cell>
      <Table.Cell>{expirationDate}</Table.Cell>
      <Table.Cell>{notes}</Table.Cell>
      <Table.Cell>{status}</Table.Cell>
      <Table.Cell>{createdAt}</Table.Cell>
      <Table.Cell>
        <Dropdown
          text='Actions'
          options={rowMenuOptions}
          icon='ellipsis horizontal'
          onChange={handleActionChange}
          inline
          item
          selectOnBlur={false}
          value={null}
        />
      </Table.Cell>
    </Table.Row>
  );
};

ListRowComponent.propTypes = {
  actionHandler: PropTypes.func.isRequired,
  auctionAccessBlacklist: PropTypes.shape({
    id: PropTypes.number,
    auctionAccessNo: PropTypes.string,
    expirationDate: PropTypes.string,
    notes: PropTypes.string,
    createdAt: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};

const ListRow = actionHandler => auctionAccessBlacklist => (
  <ListRowComponent
    actionHandler={actionHandler}
    auctionAccessBlacklist={auctionAccessBlacklist}
  />
);

export default ListRow;
